import React from 'react';
import { ORGAN_QA_LABELS } from '../../clients/viewer';
import { useSeriesLabels } from '../../hooks/useSeriesLabels';

const QA_LABELS = new Set<string>(Object.values(ORGAN_QA_LABELS));

export interface QACheckItemProps {
  instance?: { Modality?: string; StudyInstanceUID?: string; SeriesInstanceUID?: string };
  customization?: { color?: string };
}

export default function QACheckItem({ instance, customization }: QACheckItemProps) {
  const isCt = instance?.Modality === 'CT';

  const entry = useSeriesLabels(
    isCt ? instance?.StudyInstanceUID : undefined,
    isCt ? instance?.SeriesInstanceUID : undefined
  );

  const reviewedOrgans = entry?.labels.filter(label => QA_LABELS.has(label)) ?? [];

  if (!entry || reviewedOrgans.length === 0) {
    return null;
  }

  return (
    <div
      className="overlay-item flex flex-col"
      style={{ color: customization?.color }}
    >
      {entry.reviewerName ? (
        <div>
          <span>QA - {entry.reviewerName}</span>
        </div>
      ) : null}

      <div>Labels:</div>
      <ul className="ml-1">
        {reviewedOrgans.map(label => (
          <li
            key={label}
            className="shrink-0"
          >
            {label}
          </li>
        ))}
      </ul>
    </div>
  );
}
